import vueAdvisorSvc from '../../services/vueAdvisorSvc';
import vueProductSvc from '../../services/vueProductSvc';
import vueXsellSvc from '../../services/vueXsellSvc';
import { isNum } from '../../utilities/mrVueUtils';

const state = {
  boostRecommendations: [],
  showBoostOptions: false,
  selectedBoost: {},
  proProduct: {},
  xsellItems: [],
  membershipXsellProducts: [],
  productXsellItems: [],
  loadingXsell: false,
  loadingProductXsell: false
};

export const getters = {

};

export const actions = {
  initXsellItems({ state, dispatch }) {
    if (state.xsellItems.length) {
      return;
    }

    dispatch('getXsellItems');
  },

  getXsellItems({ state, commit }) {
    if (state.loadingXsell) {
      return;
    }

    commit('setLoadingXsell', true);

    vueXsellSvc.getXsellItems().then(res => {
      commit('setXsellItems', res.data);
    }).finally(() => commit('setLoadingXsell', false));
  },

  initMembershipXsellProducts({ dispatch, state }) {
    if (state.membershipXsellProducts.length) {
      return;
    }

    dispatch('getMembershipXsellProducts');
  },

  getMembershipXsellProducts({ commit }) {
    vueXsellSvc.getMembershipXsellProducts().then(res => commit('setMembershipXsellProducts', res.data));
  },

  getXsellItemsForProduct({ state, commit }, params) {
    if (state.LoadingProductXsell) {
      return;
    }

    commit('setLoadingProductXsell', true);
    vueXsellSvc.getXsellItemsForProduct(params)
      .then(res => commit('setProductXsellItems', res.data))
      .finally(() => commit('setLoadingProductXsell', false));
  },

  initBoostRecommendations({ commit, dispatch, state }) {
    if (state.boostRecommendations.length) {
      if (!state.selectedBoost.id) {
        commit('setSelectedBoost', state.boostRecommendations[0]);
      }
      return;
    }

    dispatch('getBoostRecommendations');
  },

  getBoostRecommendations({ state, commit }) {
    vueAdvisorSvc.getBoostRecommendations()
      .then(res => {
        let boosts = res.data;
        //- populate necessary props for frontend
        boosts.forEach(boost => {
          boost.qty = 1;
          boost.subscribe = true;
        });

        commit('setBoostRecommendations', boosts);
        commit('setSelectedBoost', state.boostRecommendations[0]);
      });
  },

  getProProduct({ commit }, id) {
    return new Promise((resolve, reject) => {
      vueProductSvc.getProductById({ id }).then(res => {
        commit('setProProduct', res.data);
        resolve();
      }, reject);
    });
  },

  xsellOnAdvisorUpdate({ dispatch }) {
    dispatch('getBoostRecommendations');
  },

  openPdpXsellModal({ dispatch }) {
    dispatch('modal/showModal', { component: './PDP/PdpXsellModal', theme: 'full-screen' }, { root: true });
  },
};

export const mutations = {
  setXsellItems(state, val) {
    state.xsellItems = val;
  },

  setMembershipXsellProducts(state, val) {
    state.membershipXsellProducts = val;
  },

  setBoostRecommendations(state, val) {
    state.boostRecommendations = Array.isArray(val) ? val : [];
  },

  setSelectedBoost(state, val) {
    state.selectedBoost = val || {};
  },

  setBoostQty(state, val) {
    if (!isNum(val)) {
      return;
    }

    state.selectedBoost.qty = +val;
  },

  setBoostSubscription(state, val) {
    state.selectedBoost.subscribe = val;
  },

  setShowBoostOptions(state, val) {
    state.showBoostOptions = val;
  },

  setProProduct(state, val) {
    state.proProduct = val || {};
  },

  setLoadingXsell(state, val) {
    state.loadingXsell = Boolean(val);
  },

  setProductXsellItems(state, val) {
    state.productXsellItems = val;
  },

  setLoadingProductXsell(state, val) {
    state.loadingProductXsell = Boolean(val);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
